export enum DossierFileStatus {
    Undefined = 'Undefined',
    Processing = 'Processing',
    Error = 'Error',
    Processed = 'Processed'
}
